import { EM_DASH } from 'libs.constants';
import { useDateTime } from '../../hooks';
export const FormattedDateTime = ({ date, timeZone }) => {
    const { parseDateTimeShort } = useDateTime();
    if (!date) {
        return EM_DASH;
    }
    return parseDateTimeShort(date, { timeZone });
};
